import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Modal, ModalBody } from "reactstrap";
import { getAttachmentsByValuation } from "../../../../services/ValitanApiService";

const AttachmentsTab = ({ valuationId }) => {
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        if (!valuationId) return;

        const fetchAttachments = async () => {
            try {
                setLoading(true);
                const response = await getAttachmentsByValuation(valuationId);

                if (response.status === 200 && response.data?.data?.content) {
                    setAttachments(response.data.data.content);
                } else {
                    setAttachments([]);
                }
            } catch (error) {
                console.error("Failed to fetch attachments:", error);
                setAttachments([]);
            } finally {
                setLoading(false);
            }
        };

        fetchAttachments();
    }, [valuationId]);

    if (loading) {
        return (
            <div className="text-center my-3">
                <Spinner color="primary" />
            </div>
        );
    }

    if (!attachments.length) {
        return <Alert color="info">No attachments available</Alert>;
    }

    const isPdf = (url) => url?.toLowerCase().endsWith(".pdf");

    return (
        <div>
            <h5 className="mb-3 text-primary">Attachments</h5>
            <Table bordered hover responsive>
                <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>Preview</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Uploaded At</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((att, index) => (
                        <tr key={att.id}>
                            <td>{index + 1}</td>
                            <td>
                                {att.file_url ? (
                                    isPdf(att.file_url) ? (
                                        <div
                                            className="avatar-md rounded bg-light d-flex align-items-center justify-content-center"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => window.open(att.file_url, "_blank")}
                                        >
                                            <i
                                                className="ri-file-pdf-line"
                                                style={{ fontSize: "32px", color: "red" }}
                                            ></i>
                                        </div>
                                    ) : (
                                        <img
                                            src={att.file_url}
                                            alt={att.description || att.file_type}
                                            className="avatar-md rounded"
                                            style={{ objectFit: "cover", cursor: "pointer" }}
                                            onClick={() => setPreviewImage(att.file_url)}
                                        />
                                    )
                                ) : (
                                    <div className="avatar-md rounded bg-light d-flex align-items-center justify-content-center">
                                        <i
                                            className="ri-file-pdf-line"
                                            style={{ fontSize: "24px", color: "#6c757d" }}
                                        ></i>
                                    </div>
                                )}
                            </td>
                            <td>
                                <span className="badge bg-info">{att.file_type}</span>
                            </td>
                            <td>{att.description || "-"}</td>
                            <td>{new Date(att.created_at).toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Image Preview Modal */}
            <Modal isOpen={!!previewImage} toggle={() => setPreviewImage(null)} centered size="lg">
                <ModalBody className="text-center">
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "80vh",
                                borderRadius: "10px",
                                objectFit: "contain",
                            }}
                        />
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default AttachmentsTab;
